// extracted by mini-css-extract-plugin
module.exports = {"templateVariableKey":"EditTemplateVariablesTableBody_templateVariableKey__2pt-t"};